import * as React from "react";
const SvgRefresh = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M1.5 7.5s1.504-2.049 2.725-3.271a6.75 6.75 0 1 1-1.712 6.646M1.5 7.5V3m0 4.5H6"
    />
  </svg>
);
export default SvgRefresh;
